//포지션 지원하기 유형
export enum PositionApplyEnum {
  ATS = 'ATS',
  INSIGHT = 'INSIGHT',
  CMS = 'CMS',
}
export type PositionApplyType = keyof typeof PositionApplyEnum;
